import { Popover } from '@/components/Popover';

interface LimitPopoverContentProps {
    title: string;
    hint: string;
}

export function LimitPopoverContent({ title, hint }: LimitPopoverContentProps) {
    return <Popover title={title} subtitle={hint} className="w-72" />;
}
